import { render, staticRenderFns } from "./CustomIcons.vue?vue&type=template&id=f9fda4be"
import script from "./CustomIcons.vue?vue&type=script&lang=js"
export * from "./CustomIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports